// extracted by mini-css-extract-plugin
export default {"inviteCardContainer":"InviteCard_inviteCardContainer__T1ZM8"};